import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Section from '@/components/base/Section'
import Typography from '@/components/base/Typography'

import { datasHeroRevealAnimation } from './animations'
import { cn } from '@/lib/utils'

export type DatasHeroProps = {
  title: string
  paragraph: string
}

const DatasHero = ({ title, paragraph }: DatasHeroProps) => {
  return (
    <Motion animation={datasHeroRevealAnimation}>
      {(motionRef) => (
        <Section
          ref={motionRef}
          className="mt-[11.2rem] md:mt-[15.2rem] lg:mt-0"
        >
          <Grid>
            <div
              className={cn([
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:row-start-5 lg:ml-col-start-3'
              ])}
            >
              <Typography
                variant="h1"
                component="h1"
                className={cn(
                  'text-center lg:text-left',
                  '[&>.line-wrap]:-mt-[.5rem] [&>.line-wrap]:pt-[.5rem]'
                )}
                data-motion-title
              >
                {title}
              </Typography>
            </div>

            <div
              className={cn([
                'col-span-2 md:col-span-4 md:col-start-2',
                'lg:col-auto lg:row-start-8 lg:ml-col-start-3 lg:w-col-span-6',
                'mt-spacing-lg lg:mt-0'
              ])}
            >
              <Typography
                variant="h5"
                paragraph
                className="capitalize"
                data-motion-paragraph
              >
                {paragraph}
              </Typography>
            </div>
          </Grid>
        </Section>
      )}
    </Motion>
  )
}

export default DatasHero
